import {
  EDIT_BAND_NAME,
  LOAD_BAND_INFO,
  EXPORT_BAND_INFO,
  LOAD_BAND_INFO_SUCCESS,
  LOAD_BAND_INFO_FAILURE,
  EDIT_BAND_DESC,
  EDIT_BAND_LOCATION,
  EDIT_BAND_GENRE1,
  EDIT_BAND_IS_SECOND_GENRE,
  EDIT_BAND_GENRE2,
  EDIT_BAND_PICTURE,
  SAVE_BAND_BEGIN,
  SAVE_BAND_FAILED,
  SAVE_BAND_SUCCESS,
  CHANGE_PICTURE_CROP,
} from "../actions/editbandactions";
import {
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_FAILED,
} from "../actions/logoutactions";
import { GET_REVIEW_STATES_SUCCESS } from "../actions/songactions";
import { DELETE_ACCOUNT_FINALISE_END } from "../actions/deleteaccountactions";
import { GENRES } from "../data/text";

const initialState = {
  loading: false,
  name: "",
  load_name: "",
  desc: "",
  load_desc: "",
  location: "",
  load_location: "",
  genre1: "rock",
  load_genre1: "",
  is_second_genre: false,
  load_is_second_genre: "",
  genre2: "rock",
  load_genre2: "rock",
  fileUploadName: "Choose Image",
  bandPicture: null,
  reviewState: "Unseen",
  pictureToUpload: false,
  unsaved: new Set(),
  pictureCrop: { leftTop: 0, rightTop: 0, rightBottom: 0, leftBottom: 0 },
};

export function editBandReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case EDIT_BAND_NAME:
      nextState.name = action.bandName;
      compareToLoad(
        nextState,
        nextState.name,
        nextState.load_name,
        "BAND_NAME"
      );
      return nextState;
    case EDIT_BAND_DESC:
      nextState.desc = action.desc;
      compareToLoad(
        nextState,
        nextState.desc,
        nextState.load_desc,
        "BAND_DESC"
      );
      return nextState;
    case EDIT_BAND_LOCATION:
      nextState.location = action.location;
      compareToLoad(
        nextState,
        nextState.location,
        nextState.load_location,
        "LOCATION"
      );
      return nextState;
    case EDIT_BAND_GENRE1:
      nextState.genre1 = action.genre1;
      if (nextState.genre1 === nextState.genre2) {
        nextState.genre2 = GENRES.find(item => item !== nextState.genre1)
      }
      compareToLoad(
        nextState,
        nextState.genre1,
        nextState.load_genre1,
        "GENRE_1"
      );
      return nextState;
    case EDIT_BAND_GENRE2:
      nextState.genre2 = action.genre2;
      if (nextState.genre1 === nextState.genre2) {
        nextState.genre2 = GENRES.find(item => item !== nextState.genre1)
      }
      compareToLoad(
        nextState,
        nextState.genre2,
        nextState.load_genre2,
        "GENRE_2"
      );
      return nextState;
    case EDIT_BAND_IS_SECOND_GENRE:
      nextState.is_second_genre = action.isSecondGenre;
      compareToLoad(
        nextState,
        nextState.is_second_genre,
        nextState.load_is_second_genre,
        "IS_SECOND_GENRE"
      );
      return nextState;
    case EDIT_BAND_PICTURE:
      nextState.bandPicture = action.bandPicture;
      nextState.unsaved = new Set(state.unsaved);
      nextState.reviewState = "UNSEEN";
      nextState.rejectionReason = null;
      nextState.unsaved.add("BAND_PICTURE");
      nextState.pictureToUpload = true;
      nextState.fileUploadName = "Change Image";
      return nextState;
    case LOAD_BAND_INFO:
      nextState.loading = true;
      return nextState;
    case LOAD_BAND_INFO_SUCCESS:
      nextState.loading = false;
      return nextState;
    case LOAD_BAND_INFO_FAILURE:
      nextState.loading = false;
      return nextState;
    case EXPORT_BAND_INFO:
      const bandInfo = action.bandInfo;
      const reviewInfo = action.reviewInfo;
      nextState.exists = bandInfo.exists;
      if (bandInfo.exists) {
        nextState.name = bandInfo.bandName;
        nextState.desc = bandInfo.bandDescription;
        nextState.location = bandInfo.location;
        nextState.genre1 = bandInfo.genre1 ? bandInfo.genre1 : state.genre1;
        nextState.load_genre1 = nextState.genre1;
        nextState.is_second_genre = bandInfo.genre2 !== null;
        nextState.genre2 = bandInfo.genre2;
        nextState.bandPicture = bandInfo.bandPictureUrl.url;
        nextState.pictureToUpload = false;
        nextState.pictureCrop = bandInfo.pictureCrop;
        nextState.reviewState = reviewInfo == null ? "Unseen" : reviewInfo.reviewState.status;
        nextState.rejectionReason = reviewInfo != null ? reviewInfo.reviewState.reason : null;
        nextState.fileUploadName = "Change Image";
      }
      setLoadProperties(nextState);
      nextState.unsaved = new Set();
      return nextState;
    case SAVE_BAND_BEGIN:
      nextState.loading = true;
      nextState.unsaved = new Set();
      return nextState;
    case SAVE_BAND_FAILED:
      nextState.loading = false;
      return nextState;
    case SAVE_BAND_SUCCESS:
      nextState.loading = false;
      nextState.exists = true;
      nextState.reviewState = "IN_REVIEW";
      nextState.bandPicture = action.url;
      nextState.pictureToUpload = false;
      setLoadProperties(nextState);
      return nextState;
    case GET_REVIEW_STATES_SUCCESS:
      Object.keys(action.reviewStates).some(id => {
        if (action.reviewStates[id].reviewType === "PICTURE") {
          nextState.reviewState = action.reviewStates[id].status;
          nextState.rejectionReason = action.reviewStates[id].status === "REJECTED" ? action.reviewStates[id].reason : null
          return true;
        }
        return false;
      });
      return nextState;
    case CHANGE_PICTURE_CROP:
      nextState.pictureCrop = action.pictureCrop;
      return nextState;
    case LOGOUT_BEGIN:
      nextState.loading = true;
      return nextState;
    case LOGOUT_FAILED:
      nextState.loading = false;
      return nextState;
    case LOGOUT_SUCCESS:
      return initialState;
    case DELETE_ACCOUNT_FINALISE_END:
      return initialState;
    default:
      return state;
  }
}

function setLoadProperties(state) {
  state.load_name = state.name;
  state.load_desc = state.desc;
  state.load_location = state.location;
  state.load_genre1 = state.genre1;
  state.load_is_second_genre = state.is_second_genre;
  state.load_genre2 = state.genre2;
}

function compareToLoad(nextState, value, load_value, fieldName) {
  nextState.unsaved = new Set(nextState.unsaved);
  if (value !== load_value) {
    nextState.unsaved.add(fieldName);
  } else if (nextState.unsaved.has(fieldName)) {
    nextState.unsaved.delete(fieldName);
  }
}
